import * as Sentry from '@sentry/vue';
import { FundriseRouteConfig, RawLocation } from 'vue-router';
import { app } from '@src/store/modules/app';
import { verifyEmail } from '@src/api/login';

const verifyEmailAddress = async (
	key: string,
	next: (to?: RawLocation) => void,
	visitDashOnSuccess = true
): Promise<void> => {
	try {
		const verifyEmailResponse = await verifyEmail(key);
		await app.setUserAuthData(verifyEmailResponse);
		if (visitDashOnSuccess) {
			app.ADD_TOAST({
				type: 'success',
				message: 'Your email has been successfully verified.'
			});
			next({ name: 'account-overview' });
		} else {
			next();
		}
	} catch {
		Sentry.captureMessage('Unable to verify user.');
		next({ name: 'verify-email' });
	}
};

const signupRoutes: Array<FundriseRouteConfig> = [
	{
		path: `/signup/verify-signup-checkout`,
		name: 'verify-signup-checkout',
		meta: { minTokenScopeRequired: 'UNVERIFIED' },
		component: () =>
			import(/* webpackChunkName: "verify-signup-checkout" */ '@views/checkout/checkout-success.vue'),
		beforeEnter: async (to, from, next) => {
			if (app.isVerified) {
				next();
			} else if (to.query.key && app.isAuthenticated) {
				await verifyEmailAddress(`${to.query.key}`, next, false);
			} else {
				next({ name: 'unverified-email' });
			}
		}
	},
	{
		path: `/signup/unverified-email`,
		name: 'unverified-email',
		meta: { minTokenScopeRequired: 'UNVERIFIED' },
		beforeEnter: async (to, from, next) => {
			if (app.isVerified) {
				next({ name: 'account-overview' });
			} else {
				next();
			}
		},
		component: () =>
			import(/* webpackChunkName: "unverified-email" */ '@views/email-verification/unverified-email.vue')
	},
	{
		path: `/signup/verify-email`,
		name: 'verify-email',
		meta: { minTokenScopeRequired: 'UNVERIFIED' },
		component: () =>
			import(/* webpackChunkName: "verify-email" */ '@views/email-verification/verification-failed.vue'),
		beforeEnter: async (to, from, next) => {
			if (app.isVerified) {
				next({ name: 'account-overview' });
			} else if (to.query.key && app.isAuthenticated) {
				await verifyEmailAddress(`${to.query.key}`, next);
			} else {
				next();
			}
		}
	},
	{
		path: `/signup/unverified-signup-checkout-email`,
		name: 'checkout-verify-email',
		meta: { minTokenScopeRequired: 'UNVERIFIED' },
		beforeEnter: async (to, from, next) => {
			if (app.isVerified) {
				next({ name: 'home', replace: true });
			} else {
				next();
			}
		},
		component: () =>
			import(/* webpackChunkName: "checkout-verify-email" */ '@src/views/checkout/checkout-verify-email.vue')
	}
];
export default signupRoutes;
